export default __webpack_public_path__ + "static/media/notificationIcon.14389b83.png";